import React from 'react'
import { FC } from 'react'
import styled, { keyframes } from 'styled-components'
import { Loader } from 'ui/loader'
export type Props = {
  width?: string
  height?: string
  loader?: boolean
}

export const SkeletonText: FC<{ active: boolean }> = ({ active, children, ...rest }) => (
  <SkeletonTextWrapper>{children}</SkeletonTextWrapper>
)

export const SkeletonBlock: FC<Props> = ({ loader, ...props }) => <Block {...props}>{loader && <Loader />} </Block>

const placeHolderShimmer = keyframes`
 0% {
    background-position: 100% 0
  }
  100% {
    background-position: -100% 0
  }
`

const blink = keyframes`
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.2;
  }
  100% {
    opacity: 1;
  }`

const SkeletonTextWrapper = styled.div`
  animation: ${blink} 0.9s infinite both;
  animation-delay: 0.5s;
  color: ${({ theme }) => theme.palette.grey[100]};
`

const Block = styled.div<Props>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${({ width }) => width || '100%'};
  height: ${({ height }) => height || '100%'};
  animation-duration: 1s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-name: ${placeHolderShimmer};
  animation-timing-function: linear;
  background: ${({ theme }) => theme.palette.grey[100]};
  background-image: ${({ theme }) =>
    `linear-gradient(to right, ${theme.palette.grey[100]} 0%, ${theme.palette.grey[200]} 20%, ${theme.palette.grey[100]} 40%, ${theme.palette.grey[100]} 100%)`};
  background-repeat: no-repeat;
  background-size: 200% 100%;
  color: ${({ theme }) => theme.palette.grey[300]};
`

SkeletonBlock.defaultProps = {
  width: '100%',
  height: '100%'
}
